
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Component, Prop, Watch,Mixins} from 'vue-property-decorator'
import {NoticeProps} from "@/scripts/datatypes"
import {query,where,doc,getDocs, getDoc} from 'firebase/firestore'
import Common from '@/mixins/common'
import {DateTime} from 'luxon'
import {toHan} from 'jaconv'
import { ClassData, GroupData,EventData, EventStatus, EventType, PostStatus  } from '@/common-datatypes'
import TemplateMembers from '@/components/TemplateMembers.vue'
import ModalAddClass from '@/components/ModalAddClass.vue'
import ModalAddGroup from '@/components/ModalAddGroup.vue'


interface StringDate{
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
}

@Component({
  components: {
    TemplateMembers,
    ModalAddClass,
    ModalAddGroup
  }
})

//TODO replace を時間差で実行する

export default class ModalEditEvent extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string  
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  showModalAddClass = false
  showModalAddGroup = false

  isActive = true

  notice = {} as NoticeProps

  isLoading = false

  errorMessage = ''

  title = ''

  groups: GroupData[] = []
  cls: ClassData[] = []

  innerEventData: EventData = {
    extendedProps: {}
  } as EventData

  strDate: StringDate = {
    startTime: '',
    startDate: '',
    endTime: '',
    endDate: ''
  }

  hasDeletedGroup = false
  hasDeletedClass = false

  hasEditedClass = false
  hasEditedGroup = false

  $refs!: {
    teachers: InstanceType<typeof ValidationProvider>;
    students: InstanceType<typeof ValidationProvider>;
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get disabledEditEvent(){
    return this.period <= 0  || ! this.innerEventData.title || (JSON.stringify(this.innerEventData) === JSON.stringify(this.theEventData) && !! this.innerEventData.id)
  }

  get teacherUserIds() {
    const val = this.innerEventData.extendedProps.teacherUserIds
    if(this.$refs.teachers && this.eventType === 'lesson'){
      this.$refs.teachers.validate()
    }
    return val
  }

  set teacherUserIds(userIds: string[]) {
    this.innerEventData.extendedProps = {
      ...this.innerEventData.extendedProps,
      teacherUserIds: userIds,
    }
  }

  get studentUserIds(){
    const val = this.innerEventData.extendedProps.studentUserIds
    if(this.$refs.students && this.eventType === 'lesson'){
      this.$refs.students.validate()
    }
    return val
  }

  set studentUserIds(userIds: string[]) {
    this.innerEventData.extendedProps = {
      ...this.innerEventData.extendedProps,
      studentUserIds: userIds,
    }
  }

  getDateTime(date: string, time: string){
    let dT = DateTime.fromISO(date).setZone(this.innerEventData.timeZone).startOf('day')
    const hhMm = time.split(':')
    if(hhMm.length == 2){
      let hour = parseInt(hhMm[0],10)
      hour = isNaN(hour) ? 0 : hour
      let minute = parseInt(hhMm[1],10)
      minute = isNaN(minute) ? 0 : minute
      dT = dT.plus({hours: hour , minutes: minute})
    }
    return dT
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  set postStatus(val: PostStatus){
    this.innerEventData.extendedProps.postStatus = val
  }

  get postStatus() {
    return this.innerEventData.extendedProps.postStatus
  }

  eventStatuses(){
    if(this.$te('event.status')){
      return this.$t('event.status') as unknown as EventStatus
    }
    return undefined;
  }

  set eventStatus(val: EventStatus){
    this.innerEventData.extendedProps.status = val
  }

  get eventStatus() {
    return this.innerEventData.extendedProps.status
  }

  eventTypes() {
    if(this.$te('event.type')){
      return this.$t('event.type') as unknown as {[key in EventType]: string}
    }
    return undefined;
  }

  get eventType() {
    return this.innerEventData.extendedProps.type
  }

  set eventType(val: EventType){
    if(this.eventType === 'lesson'){
      if(this.$refs.teachers){
        this.$refs.teachers.reset()
      }
      if(this.$refs.students){
        this.$refs.students.reset()
      }
    }else{
      if(this.$refs.hosts){
        this.$refs.hosts.reset()
      }
      if(this.$refs.guests){
        this.$refs.guests.reset()
      }
    }
    this.innerEventData.extendedProps.type = val
  }

  get groupId(): string {
    return this.innerEventData.extendedProps.groupId
  }

  set groupId(val: string){
    //console.log(this.innerEventData)
    const group = this.groups.find((group) => {
      if(group.groupId === val){
        return true
      }
      return false
    })

    if(group){
      this.innerEventData.extendedProps.groupId = val
      this.innerEventData.extendedProps.groupName = group.name || ''
      this.innerEventData.extendedProps.memberMeta = group.memberMeta || {}
      this.innerEventData.extendedProps.memberUserIds = group.memberUserIds || []
      this.innerEventData.extendedProps.hostUserIds = group.hostUserIds || []
      this.innerEventData.extendedProps.guestUserIds = group.guestUserIds || []
      this.innerEventData.extendedProps.groupRef = doc(this.$getGroupsColRef(),val)

      this.hasDeletedGroup = false
      this.hasEditedGroup = false
    }else{
      this.innerEventData.extendedProps.groupId = ''
      this.innerEventData.extendedProps.groupName = ''
      this.innerEventData.extendedProps.memberMeta = {}
      this.innerEventData.extendedProps.memberUserIds = []
      this.innerEventData.extendedProps.hostUserIds = []
      this.innerEventData.extendedProps.guestUserIds = []
      delete this.innerEventData.extendedProps.groupRef
    }
    

  }

  get classId() {
    return this.innerEventData.extendedProps.classId
  }

  set classId(val){
    const cl = this.cls.find((cl) => {
      if(cl.classId === val){
        return true
      }
      return false
    })

    if(cl){
      this.innerEventData.extendedProps.classId = val
      this.innerEventData.extendedProps.className = cl.name || ''
      this.innerEventData.extendedProps.memberMeta = cl.memberMeta || {}
      this.innerEventData.extendedProps.memberUserIds = cl.memberUserIds || []
      this.innerEventData.extendedProps.teacherUserIds = cl.teacherUserIds || []
      this.innerEventData.extendedProps.studentUserIds = cl.studentUserIds || []
      this.innerEventData.extendedProps.classRef = doc(this.$getClassesColRef(),val)
      this.hasDeletedClass = false
      this.hasEditedClass = false
    }else{
      this.innerEventData.extendedProps.classId = ''
      this.innerEventData.extendedProps.className = ''
      this.innerEventData.extendedProps.memberMeta = {}
      this.innerEventData.extendedProps.memberUserIds = []
      this.innerEventData.extendedProps.teacherUserIds = []
      this.innerEventData.extendedProps.studentUserIds = []
      delete this.innerEventData.extendedProps.classRef
    }
    //console.log(this.innerEventData)

  }

  get startDate(): string {
    return this.strDate.startDate
  }

  set startDate(val: string){
    if(! val){
      return 
    }

    this.strDate.startDate = val

    if(this.getPeriod() <= 0){
      const start = this.getDateTime(this.strDate.startDate, this.strDate.startTime)
      const end = start.plus({minutes: this.initPeriod})
      this.strDate.endDate = end.toFormat('yyyy-LL-dd')
    }
  }

  get endDate(): string {
    return this.strDate.endDate
  }

  set endDate(val: string){
     if(! val){
      return 
    }
    this.strDate.endDate = val
  }

  get startTime(): string {
    return this.strDate.startTime
  }

  set startTime(val: string){
    this.strDate.startTime = this.inputTimeFormat(val,this.startTime)
    if(this.getPeriod() <= 0 && this.strDate.startTime.length === 5){
      const start = this.getDateTime(this.strDate.startDate, this.strDate.startTime)
      const end = start.plus({minutes: this.initPeriod})
      this.strDate.endDate = end.toFormat('yyyy-LL-dd')
      this.strDate.endTime = end.toFormat('HH:mm')
    }
  }

  get endTime(): string {
    return this.strDate.endTime
  }

  set endTime(val: string) {
    this.strDate.endTime = this.inputTimeFormat(val,this.endTime)
    /*
    if(this.getPeriod() <= 0 && this.strDate.endTime.length === 5){
      const end = this.getDateTime(this.strDate.endDate, this.strDate.endTime)
      const start = end.minus({minutes: this.initPeriod})
      this.strDate.startDate = start.toFormat('yyyy-LL-dd')
      this.strDate.startTime = start.toFormat('HH:mm')
    }
    */
  }


  @Watch('strDate', {deep: true})
  updateDate(){
    this.period = this.getPeriod()
  }

  period = 0

  initPeriod = 0

  getPeriod(){
    const start = this.getDateTime(this.strDate.startDate, this.strDate.startTime)
    const end = this.getDateTime(this.strDate.endDate, this.strDate.endTime)
    this.innerEventData.start = start.toJSDate()
    this.innerEventData.end = end.toJSDate()
    return end.diff(start,'minutes').minutes
  }

  get hostUserIds() {
    const val = this.innerEventData.extendedProps.hostUserIds
    if(this.$refs.hosts && this.eventType !== 'lesson'){
      this.$refs.hosts.validate()
    }
    return val
  }

  set hostUserIds(userIds: string[]) {
    this.innerEventData.extendedProps = {
      ...this.innerEventData.extendedProps,
      hostUserIds: userIds,
    }
  }

  get guestUserIds(){
    const val = this.innerEventData.extendedProps.guestUserIds

    if(this.$refs.guests && this.eventType !== 'lesson'){
      this.$refs.guests.validate()
    }
    return val
  }

  set guestUserIds(userIds: string[]) {
    this.innerEventData.extendedProps = {
      ...this.innerEventData.extendedProps,
      guestUserIds: userIds,
    }
  }

  get selectedClass() {
    return this.cls.find((cl)=>{return cl.classId === this.classId})
  }

  get selectedGroup(){
    return this.groups.find((group)=>{return group.groupId === this.groupId})
  }

  inputTimeFormat(val: string, pre: string){
    val = toHan(val)
    
    if(val.replace(/\D/,'').length < pre.replace(/\D/,'').length){
      return val
    }

    val = val.replace(/[^\d:]/g,'')

    val = val.replace(/^:/,'')

    val = val.replace(/:{2}/,':')

    val = val.replace(/(:\d+):/,'$1')

    val = val.replace(/^(.{5}).+$/,'$1')

    val = val.replace(/^(\d{2})(\d{1,2}).*$/,'$1:$2')

    if(/^[3-9]$/.test(val)){
      val = '0' + val + ':'
    }else if(/^\d{2}$/.test(val)){
      val = val + ':'
    }else if( /^\d{2}:[6-9]$/.test(val)){
      val = val.replace(':',':0')
    }

    return val
  }

 
  @Watch('errorMessage')
  changeErrorMessage(newVal: string){
    //console.log(newVal)
    if(newVal != ''){
      /*
      this.observer.setErrors({
        title: this.$te(newVal) ? this.$t(newVal) as string : newVal
      })
      */

      this.notice = {
        message: newVal,
        duration: 0,
        deleteButton: true,
        type: {'is-danger': true},
        isShow: true
      }
    }
  }

  async created(){
    try{
      this.isActive = true

      if(this.theEventData){
        this.innerEventData = {...this.theEventData}
        this.innerEventData.extendedProps = {...this.theEventData.extendedProps}
        console.log(this.innerEventData)
        const timeZone = this.theEventData.timeZone
        this.title = this.theEventData.title || ''
        
        let start = DateTime.fromJSDate(this.theEventData.start).setZone(timeZone)
        let end = DateTime.fromJSDate(this.theEventData.end).setZone(timeZone)

        if(! start.isValid){
          start = DateTime.now().setZone(timeZone).startOf('hour')
        }

        this.strDate.startDate = start.toFormat('yyyy-LL-dd')
        this.strDate.startTime = start.toFormat('HH:mm')

        if(! end.isValid){
          end = start.plus({hour: 1})
        }

        this.strDate.endDate = end.toFormat('yyyy-LL-dd')
        this.strDate.endTime = end.toFormat('HH:mm')

        this.initPeriod = end.diff(start,'minutes').minutes

        const classesRef = await getDocs(query(this.$getClassesColRef(),where('deleted','==',false),where('disabled','==',false)))
        this.cls = classesRef.docs.map((doc) => {
          const row = doc.data() as ClassData
          return {classId: doc.id,...row}
        });

        const className = this.theEventData.extendedProps.className
        const classId = this.theEventData.extendedProps.classId

        const teacherUserIds = this.innerEventData.extendedProps.teacherUserIds
        const studentUserIds = this.innerEventData.extendedProps.studentUserIds


        /**
         * classが削除や変更のときの処理
         */

        if(className && classId){
          if(! this.cls.some((cl) => {return cl.classId === classId && cl.name === className})){
            this.hasDeletedClass = true
          }
        }

        if(this.selectedClass){
          if(teacherUserIds.some((userId) => {return Array.isArray(this.selectedClass?.teacherUserIds) && this.selectedClass?.teacherUserIds.includes(userId) === false}) || studentUserIds.some((userId) => {return Array.isArray(this.selectedClass?.studentUserIds) && this.selectedClass?.studentUserIds.includes(userId) === false})){
            this.hasEditedClass = true
          }
        }
      
        const groupsRef = await getDocs(query(this.$getGroupsColRef(),where('deleted','==',false),where('disabled','==',false)))
        this.groups = groupsRef.docs.map((doc) => {
          const row = doc.data() as GroupData
          return {groupId: doc.id,...row}
        });
  
        const groupName = this.theEventData.extendedProps.groupName
        const groupId = this.theEventData.extendedProps.groupId

        const hostUserIds = this.innerEventData.extendedProps.hostUserIds
        const guestUserIds = this.innerEventData.extendedProps.guestUserIds

        /**
         * groupが削除や変更のときの処理
         */

        if(groupName && groupId){
          if(! this.groups.some((group) => {return group.groupId === groupId && group.name === groupName})){
            this.hasDeletedGroup = true
          }
        }

        if(this.selectedGroup){
          if(hostUserIds.some((userId) => {return Array.isArray(this.selectedGroup?.hostUserIds) && this.selectedGroup?.hostUserIds.includes(userId) === false}) || guestUserIds.some((userId) => {return Array.isArray(this.selectedGroup?.guestUserIds) && this.selectedGroup?.guestUserIds.includes(userId) === false})){
            this.hasEditedGroup = true
          }
        }
      }
    }catch(error){
      console.log(error)
    }
  }

  async onConfirm(yes: boolean | EventData) {  
    this.$emit("onConfirm", yes);
  }

  updateClassList(newClassData: ClassData){
    this.cls.unshift(newClassData)
  }

  updateGroupList(newGroupData: GroupData){
    this.groups.unshift(newGroupData)
  }

  async editEvent(){
    try{
      if(! await this.$refs.validationObserver.validate()){
        return
      }

      this.$store.commit("setLoading",true)
      this.isLoading = true

      const data = {
        ...this.innerEventData
      }

      if(this.innerEventData.extendedProps.type === 'lesson'){
        data.extendedProps = {
          ...data.extendedProps,
          guestUserIds: [],
          hostUserIds: [],
          groupName: '',
          groupId: '',
        }
      }else {
        data.extendedProps = {
          ...data.extendedProps,
          teacherUserIds: [],
          studentUserIds: [],
          className: '',
          classId: '',
        }
      }

      data.extendedProps = {
          ...data.extendedProps,
           memberUserIds: Array.from(new Set(data.extendedProps.teacherUserIds.concat(data.extendedProps.guestUserIds).concat(data.extendedProps.hostUserIds).concat(data.extendedProps.studentUserIds)))
        }

      if(data.extendedProps.classId === ''){
        delete data.extendedProps.classRef
      }

      if(data.extendedProps.groupId === ''){
        delete data.extendedProps.groupRef
      }

      
      const eventsColRef = this.$getEventsColRef()
      console.log('editEvent')
      console.log(data)
      const theEventDocData = this.$eventObjectToEventDocData(data)
      const docId = theEventDocData.docId
      //const eventId = theEventDocData.id
      let updateEventDoc
      if(docId){
        const theEventDoc = doc(eventsColRef,docId)
        const theEventData = await getDoc(theEventDoc)
        if(theEventData.exists()){
          updateEventDoc = await this.$updateDoc(theEventDoc,theEventDocData)
        }
      }else{
        updateEventDoc = await this.$createDoc(eventsColRef,theEventDocData)
      }
      if(updateEventDoc){
        const updateEventData = updateEventDoc.data() as EventData
        this.onConfirm(updateEventData)
      }
    }catch(error){
      console.log(error)
      const code = this.$getErrorCode(error)
      const message = this.$getErrorMessageKey(code)
      this.errorMessage = message
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
